module.exports = __webpack_public_path__ + "static/media/icon-search.2430a703.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-search.svg
// module id = 566
// module chunks = 0